import React from "react";
import "./Promotion.css";
import MandalaCard from "../../../widgets/MandalaCard/MandalaCard";

const Promotion = () => {
  return (
    <MandalaCard title="EN CE MOMENT">
      <wp-widget slug="moment"></wp-widget>
    </MandalaCard>
  );
};

export default Promotion;
